import { VFC } from "react";
import { Helmet } from "react-helmet-async";

type Props = {
  title?: string;
};

export const PageTitle: VFC<Props> = (props) => {
  const { title } = props;
  return (
    <Helmet>
      <title>{title ?? "MDM App"}</title>
    </Helmet>
  );
};
